import { formatQuarter, parseQuarter } from './periodRange';
import {
  PeriodRangePicker,
  SharedPeriodRangePickerProps,
} from './PeriodRangePicker';

export type QuarterRangePickerProps = SharedPeriodRangePickerProps;

export function QuarterRangePicker(props: QuarterRangePickerProps) {
  return (
    <PeriodRangePicker
      {...props}
      type="quarter"
      periodsPerYear={4}
      format={formatQuarter}
      parse={parseQuarter}
      formatGridPeriod={(quarter) => `Q${quarter}`}
    />
  );
}
